import { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  SiteSettingsContext,
  useCookieManagementEnabled
} from '@namespace/cms';
import { COOKIES_KEYS, getCookie, IS_PRERENDER } from '@namespace/helpers';
import {
  getAvailableLanguageFromPath,
  getBrowserLanguage,
  i18nActions,
  updateUrlLang,
  useI18nStore
} from '@namespace/i18n';
import { useSyncLangUrlStore } from './useSyncLangUrlStore';

const { SET_INITIAL_LANG_TRANSLATIONS } = i18nActions;

export const useInitLanguage = (isSiteSettingsReady) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [settings] = useContext(SiteSettingsContext);
  const { siteConfig = {}, otherSettings = {} } = settings || {};
  const {
    isReplaceRuBrowserLanguage = false,
    hiddenLanguageInUrl,
    isLoadFallbackTranslations
  } = otherSettings;
  const {
    defaultLanguage,
    languages = [],
    useBrowserLanguage = true,
    prerenderLang
  } = siteConfig;
  const cookieManagementEnabled = useCookieManagementEnabled();

  useEffect(() => {
    (async () => {
      const { isTranslationsInitialized } = useI18nStore.getState();
      if (isSiteSettingsReady && !isTranslationsInitialized) {
        // detect language
        const browserLanguage = getBrowserLanguage();
        const langInCookie = getCookie(COOKIES_KEYS.LANGUAGE);
        const availableBrowserLanguage = languages.find((lang) =>
          browserLanguage.includes(lang)
        );
        const finalBrowserLanguage =
          isReplaceRuBrowserLanguage && availableBrowserLanguage === 'ru'
            ? 'uk'
            : availableBrowserLanguage;
        const languageFromPath = getAvailableLanguageFromPath(
          location.pathname,
          languages
        );
        const detectedLanguage = useBrowserLanguage
          ? finalBrowserLanguage || defaultLanguage
          : defaultLanguage;
        const language = (IS_PRERENDER && prerenderLang) || detectedLanguage;
        const lang = languageFromPath || langInCookie || language;

        // update initial language in url
        const newLocation = updateUrlLang(location, lang, hiddenLanguageInUrl);
        navigate(newLocation, { replace: true });

        // initial language detected - set it
        await SET_INITIAL_LANG_TRANSLATIONS({
          lang,
          cookieManagementEnabled,
          isLoadFallbackTranslations
        });
      }
    })();
  }, [isSiteSettingsReady]);

  useSyncLangUrlStore();
};
